module.exports = __webpack_public_path__ + "img/dd@2x.9ad18c0f.png";